"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var utils_1 = require("./utils");
var defaultValues = {
    localdata: {},
    saveLocaldata: Promise.resolve,
    removeLocaldata: Promise.resolve,
    clearLocaldata: Promise.resolve,
};
var LocaldataContext = react_1.createContext(defaultValues);
exports.LocaldataContext = LocaldataContext;
LocaldataContext.displayName = 'LocaldataContext';
var LocaldataProvider = /** @class */ (function (_super) {
    tslib_1.__extends(LocaldataProvider, _super);
    function LocaldataProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: _this.props.defaultData,
        };
        _this.syncData();
        _this.save = _this.save.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        _this.clear = _this.clear.bind(_this);
        return _this;
    }
    LocaldataProvider.prototype.syncData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.getData(this.props.defaultData)];
                    case 1:
                        data = _a.sent();
                        this.setState({ data: data });
                        return [2 /*return*/];
                }
            });
        });
    };
    LocaldataProvider.prototype.save = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.saveData(data)];
                    case 1:
                        _a.sent();
                        this.syncData();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocaldataProvider.prototype.removeItem = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.removeItem(key)];
                    case 1:
                        _a.sent();
                        this.syncData();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocaldataProvider.prototype.clear = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.clearData()];
                    case 1:
                        _a.sent();
                        this.syncData();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocaldataProvider.prototype.render = function () {
        var value = {
            localdata: this.state.data,
            saveLocaldata: this.save,
            removeLocaldata: this.removeItem,
            clearLocaldata: this.clear,
        };
        return (react_1.createElement(LocaldataContext.Provider, { value: value }, this.props.children));
    };
    LocaldataProvider.displayName = 'LocaldataProvider';
    return LocaldataProvider;
}(react_1.Component));
exports.LocaldataProvider = LocaldataProvider;
var Localdata = LocaldataContext.Consumer;
exports.Localdata = Localdata;
